import { Link } from "react-router-dom";

export function LoadingState({ label = "正在加载影视内容…" }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <span
        className="h-10 w-10 animate-spin rounded-full border-2 border-background-300 border-t-accent-500"
        aria-hidden="true"
      ></span>
      <p className="text-sm text-foreground-500">{label}</p>
    </div>
  );
}

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-2xl text-foreground-400">
        <i className={icon} aria-hidden="true"></i>
      </span>
      <h3 className="font-heading text-base font-bold text-foreground-900">{title}</h3>
      {description && <p className="max-w-md text-sm text-foreground-500">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}